import { useMemo } from "react"

import { useTestSetsListTransport } from "@/test-set/transport"

import type { TestSetRecord } from "@/types/api/TestSetRecord"

type TestSetsListData = TestSetRecord[]

interface LookupHookOptions {
  enabled?: boolean
}

interface UseTestSetsListOptions<T> {
  enabled?: boolean
  select?: (data: TestSetsListData) => T
  tagFilters?: string[]
}

export function useTestSetsList<T = TestSetsListData>(
  options?: UseTestSetsListOptions<T>,
) {
  return useTestSetsListTransport(options)
}

export const useTestSetsById = (options?: LookupHookOptions) => {
  const { data, isLoading, isError, error } = useTestSetsList({
    enabled: options?.enabled,
  })

  const testSetsById = useMemo(() => {
    return (data || []).reduce<Record<string, TestSetRecord>>(
      (acc, testSet) => {
        if (testSet) {
          acc[testSet.id] = testSet
        }
        return acc
      },
      {},
    )
  }, [data])

  return {
    testSetsById,
    isLoading,
    isError,
    error,
  }
}
